import React from 'react';
import styles from './styles.module.scss';
import classnames from 'classnames';
import colorVariables from '@densityco/ui/variables/colors.json';

export type ChipProps = {
  size?: 'small' | 'medium' | 'large';
  backgroundColor?: string;
  color?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

const Chip: React.FunctionComponent<ChipProps> = ({
  size = 'medium',
  backgroundColor = colorVariables.gray100,
  color = colorVariables.gray700,
  leftIcon = null,
  rightIcon = null,
  children,
}) => {
  return (
    <span
      className={classnames(styles.chip, {
        [styles.small]: size === 'small',
        [styles.medium]: size === 'medium',
        [styles.large]: size === 'large',
      })}
      style={{backgroundColor, color}}
    >
      {leftIcon}
      {children}
      {rightIcon}
    </span>
  )
};

export default Chip;
